module.exports = __webpack_public_path__ + "static/media/majorG5.3f9888a.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/sing/majorG5.wav
// module id = wmvI
// module chunks = 0